<template>
    <section>
        <sui-table width="100%" :class="{ 'selectable': navigate.value }" :selectable="selectable">
            <sui-table-header>
                <sui-table-row v-show="activeSearch">
                    <sui-table-header-cell class="txtc" :colspan="headers.length">
                        <slot name="search">
                            <sui-form @submit.prevent>
                                <sui-form-fields>
                                    <sui-form-field width="four" class="txtl">
                                        <label>Búsqueda:</label>
                                        <input type="text" v-model="localKeyword" placeholder="Busqueda por palabra clave"/>
                                    </sui-form-field>
                                </sui-form-fields>
                            </sui-form>
                        </slot>
                    </sui-table-header-cell>
                </sui-table-row>
                <sui-table-row v-if="title">
                    <sui-table-header-cell class="txtc" :colspan="headers.length">
                        <h4 class="ui header" :class="titleColor ? titleColor : ''">{{ title | uppercase }}</h4>
                    </sui-table-header-cell>
                </sui-table-row>
                <sui-table-row>
                    <sui-table-header-cell
                        v-for="(header, index) in headers"
                        :key="index"
                        :class="header.class ? header.class: ''"
                    >
                        <slot name="checkboxHeader" v-if="header.type === 'checkbox'">
                            <sui-checkbox
                                v-model="allSelected"
                                @click="toogleSelectAll"
                            />
                        </slot>
                        <!-- If a tooltip for help/info is needed, just add tooltip key on header object -->
                        <div v-if="header.tooltip"  class="header-cell">
                            <span>{{ header.name }}</span>
                            <i
                            v-if="header.tooltip"
                            class="orange question circle icon"
                            v-tooltip.top-center
                            v-tooltip="{ content: header.tooltip }"
                            ></i>
                        </div>
                        <span v-else>{{ header.name }}</span>
                    </sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>
            <sui-table-body>
                <sui-table-row v-if="tableRecords.length === 0">
                    <sui-table-cell textAlign="center" :colspan="headers.length"><strong>No se encontraron registros</strong></sui-table-cell>
                </sui-table-row>
                <sui-table-row v-for="(item, index) in tableRecords" :key="index" @click="onNavigate(item.id)" :class="rowClass(item)">
                    <sui-table-cell
                        v-for="(header, indexHeader) in headers"
                        :key="indexHeader"
                        :class="header.cellclass"
                        :width="header.width ? header.width : 2"
                    >
                        <span v-if="header.type === 'object'"> {{ (item[header.key] && item[header.key][header.value] !== undefined ? item[header.key][header.value] : 'Indefinido') | dynamicFilter(header.filter) }}</span>
                        <slot :name="header.slotName" v-else-if="header.type === 'slot'" :item="item"/>
                        <span v-else-if="header.defaultNullValue && !item[header.value]"> {{ header.defaultNullValue }}</span>
                        <span v-else-if="header.type === 'currency'">{{ item[header.value] | currency }}</span>
                        <span v-else-if="header.type === 'date'">{{ item[header.value] | date }}</span>
                        <span v-else-if="header.type === 'dateShort'">{{ item[header.value] | dateShort }}</span>
                        <span v-else-if="header.type === 'dateTime'">{{ item[header.value] | dateTime }}</span>
                        <span v-else-if="header.type === 'percentage'">{{ item[header.value] | percentage(header.decimals, header.base) }}</span>
                        <span v-else-if="header.type === 'boolean'">{{ item[header.value] ? 'Si' : 'No' }}</span>
                        <span v-else-if="header.type === 'button'">
                            <sui-button positive size="mini" @click="$emit(header.callback, item.id)">{{header.value}}</sui-button>
                        </span>
                        <span v-else-if="header.type === 'negativeButton'">
                            <sui-button negative size="mini" @click="$emit(header.callback, item)">{{header.value}}</sui-button>
                        </span>
                        <span v-else-if="header.type === 'checkbox'" @click.stop>
                            <slot name="checkboxItem" :item="item">
                                <sui-checkbox
                                    v-model="item.selected"
                                    @click="$emit('update:selectedItems', getSelected)"
                                />
                            </slot>
                        </span>
                        <span v-else-if="header.type === 'function'">{{ $parent.processFunction(header.callback, item) }}</span>
                        <span v-else-if="header.type === 'renderOption'">
                            {{ Utils.displayOptionName(header.options, item[header.value]) }}
                        </span>
                        <span v-else-if="header.type === 'template'">
                            <div v-if="header.value === 'status'">
                                <h4 is="sui-header" :color="displayCreditStatusName(item[header.value]).color">{{displayCreditStatusName(item[header.value]).name}}</h4>
                            </div>
                        </span>
                        <div v-else-if="header.type === 'popup'" class="ui icon">
                            <i class="large icon" :class="header.classTooltip || 'comments gray'"
                                v-tooltip.top-center
                                v-tooltip="{ content: item[header.value]}"
                                v-if="item[header.value] && !Utils.isObjectEmpty(item[header.value])">
                            </i>
                        </div>
                        <span v-else>{{ item[header.value] || '-' }}</span>
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>
        </sui-table>
    </section>
</template>

<script>

import Mixins from '@/mixins/index.js'

export default {
    name: 'GenericUnPaginatedList',
    props: {
        selectable: { type: Boolean, default: () => false },
        title: { type: String },
        titleColor: { type: String },
        headers: {
            type: Array,
            default: () => []
        },
        records: {
            type: Array,
            required: false,
            default: () => []
        },
        selectedItems: {
            type: Array,
            required: false,
            default: () => []
        },
        filters: {
            type: Object,
            required: false,
            default: () => Object.assign({})
        },
        recordName: {
            type: String,
            required: false
        },
        activeSearch: {
            type: Boolean,
            default: false
        },
        keyword: {
            type: String,
            default: null
        },
        navigate: {
            type: Object,
            default: () => Object.assign({
                value: false,
                blank: false
            })
        }
    },
    mixins: [ Mixins ],

    data () {
        return {
            localKeyword: null,
            allSelected: false
        }
    },

    methods: {
        toogleSelectAll () {
            let selectedIds = []
            for (const record of this.records) this.Vue.set(record, 'selected', this.allSelected)
            selectedIds = this.records.filter(item => !!item.selected).map(item => item.id)
            this.$emit('update:selectedItems', selectedIds)
        },

        onNavigate (id) {
            if (this.navigate.value) {
                if (this.navigate.blank) this.newTabTo(id)
                else this.navigateTo(id)
            }
        },

        rowClass (item) {
            return {
                'clickable highlightrow': this.navigate.value === true,
                'negative': this.shouldMarkRed(item)
            }
        },

        shouldMarkRed (item) {
            return item && item.active === false
        }
    },

    computed: {
        getSelected () {
            return this.records.filter(item => item.selected).map(item => item.id)
        },

        tableRecords () {
            let records = this.records.map(item => item)
            const flatten = (obj, depth = 2, currentDepth = 0, path = '') => {
                currentDepth++
                if (!(obj instanceof Object)) return { [path.replace(/\.$/g, '')]: obj }

                return Object.keys(obj).reduce((output, key) => {
                    if (currentDepth > depth) return output
                    return obj instanceof Array
                        ? { ...output, ...flatten(obj[key], depth, currentDepth, path + '[' + key + '].') }
                        : { ...output, ...flatten(obj[key], depth, currentDepth, path + key + '.') }
                }, {})
            }

            if (this.localKeyword) records = this.records.filter(item => Object.values(flatten(item)).toString().toUpperCase().includes(this.localKeyword.toUpperCase()))

            for (const filterKey of Object.keys(this.filters)) {
                if (this.filters[filterKey].value && this.filters[filterKey].value.length) {
                    records = records.filter(item => {
                        if (this.filters[filterKey].type === Array) {
                            return this.filters[filterKey].value.includes(item[filterKey])
                        } else {
                            return item[filterKey].toString().toUpperCase().includes(this.filters[filterKey].value.toString().toUpperCase())
                        }
                    })
                }
            }

            return records
        }
    },

    watch: {
        keyword: function () {
            if (this.activeSearch) this.localKeyword = this.keyword
        }
    }
}
</script>

<style scoped>
    .ui.table thead {
        top: 0;
        z-index: 2;
        position: sticky !important;
    }

    .header-cell {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }

    .header-cell .icon {
        font-size: 1.5em;
        cursor: help;
    }
</style>
